/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Filter from './filter'
import Collection from './collection'
import User from './user'

export default class Subusers extends Collection {
  get model () { return User }

  initialize () {
    this.filter = new Filter()
  }

  url () {
    return '/api/account/users'
  }

  search (term) {
    return this.fetch({
      data: {
        search: term
      }
    })
  }

  params (obj) {
    if (obj != null) {
      return this.filter.set(obj)
    } else {
      return this.filter.attributes
    }
  }
}
